import {Button, Form, FormControl, FormGroup} from 'react-bootstrap';
import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom'
import {isLoggedIn} from '../Helper Functions/UserFunction'
import axios from 'axios';
import objeler, {applyAccountContext} from '../components/objeler'
import store from '../redux/store';
import axiosInstance from '../components/token/axiosInstance'
class Login extends Component<props> {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            validated: false,
            error: false,
            errorText: null,
            wrongUser: false,
            errorText: '',
            wrongPassword: false
        };
    }

    componentDidMount() {
        // clearInterval(interval);
        let i = sessionStorage.getItem("i")
        if (i !== null) {
            let ii = parseInt(i)
            clearInterval(parseInt(i));
            console.log('SES ınt', ii)
            sessionStorage.clear()
        }

    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    async handleSubmit(e) {
        console.log('window.GET_API_URL(process.env.REACT_APP_SERVICE)', window.GET_API_URL(process.env.REACT_APP_SERVICE))
        var isError = false;
        var errText = '';
        this.setState({wrongUser: false});
        this.setState({wrongPassword: false});
        const form = e.currentTarget;
        e.preventDefault();
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else {
            var token = '';
            const data = new FormData();
            data.append('Email', this.state.email);
            data.append('Password', this.state.password);
            data.append('SessionId', store.getState().appReducers.SessionId);
            console.log('SES', store.getState())
            console.log('LOGIN URL', window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/login')
            await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/login', data
            ).then((response) => {
                // M3.5/H4 — removed: console.log('response', response)
                // The full response payload contains response.data.Token.AccessToken
                // and would have logged the bearer to the browser console on every
                // login. Production no-op (index.js) is the second layer; this is
                // the source-level remove.
                if (response.data.status >= 100) {
                    e.stopPropagation();
                    if (response.data.status == 100) {
                        this.setState({wrongUser: true, errorText: 'Hatalı Kullanıcı'});
                        this.setState({wrongPassword: false});
                        return;
                    }
                    if (response.data.status == 101) {
                        this.setState({wrongUser: false, errorText: ''});
                        this.setState({wrongPassword: true});
                        return;
                    }
                }
                if (response.data.toString().startsWith('dublicate')) {
                    let ret = response.data.split(";");
                    if (ret.length > 1) {
                        let sc = ret[1]
                        if (sc === "0")
                            sc = "1"
                        this.setState({
                            wrongUser: true,
                            errorText: 'Another session has been opened with this user. When you log in, the other session will be closed.You can log in after ' + sc + ' second' + (sc != '1' ? 's' : '') + '.'
                        });
                        this.setState({wrongPassword: false});
                        return;
                    }
                }
                objeler.User = response.data;
                // M3.5/H4 — removed: console.log("USER", objeler.User)
                // objeler.User holds the full Token { AccessToken, RefreshToken }
                // and would have logged it on every login.
                token = response.data.token;
                objeler['token'] = token;

                // ─── M2: extract multi-tenant claims from JWT ───
                // The backend's access token carries accountId, role,
                // and accountName. We pull them out of the JWT and
                // attach them to objeler.User so the rest of the app
                // (Document Explorer tabs, Header, Share buttons) can
                // read them without decoding the token themselves.
                const accessToken = response.data?.Token?.AccessToken
                                 || response.data?.token?.accessToken
                                 || response.data?.AccessToken;
                const hasContext = applyAccountContext(accessToken);
                // M3.5/H4 — removed: console.log('M2 account context applied:', ...)
                // Logged accountId/accountName/role on every login. Not a token,
                // but tenant-identifying info shouldn't sit in browser console.
                void hasContext;   // keep var (some callers may inspect)

                this.props.history.push({
                    pathname: '/frame',
                    state: {fromUrl: 'Login'}
                })
            }).catch((error) => {
                console.log('ERR', error)
                isError = true;
                this.setState({wrongUser: true, errorText: 'Network error'});
            });
        }
        this.setState({validated: true});
    }

    render() {
        const errorMsg = (
            <div style={{color: "white"}}>
                Error: Username or Password is incorrect.
            </div>
        );
        var redir = false;
        try {
            redir = this.props.location.state.redir
        } catch {
        }
        if (isLoggedIn() && !redir) {
            return <Redirect to="/frame"/>;
        }
        return (
            <div className="Login">
                <h1 style={{paddingBottom: "20px", fontWeight: "500", color: "white"}}>
                    Welcome to PDF Designer!
                </h1>
                <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit.bind(this)}>
                    <FormGroup controlId="email"
                    >
                        <FormControl
                            autoFocus
                            type="email"
                            required
                            value={this.state.email}
                            placeholder="Email*"
                            onChange={e => this.setState({email: e.target.value})}
                        />
                        <Form.Control.Feedback type="invalid"
                                               style={{color: '#FF666C'}}
                        >
                            Please provide a valid email.
                        </Form.Control.Feedback>
                        <div
                            style={{visibility: this.state.wrongUser ? 'visible' : 'hidden', color: '#FF666C'}}
                        >
                            {this.state.errorText}
                        </div>
                    </FormGroup>
                    <FormGroup controlId="password"
                    >
                        <FormControl
                            type="password"
                            autoComplete="off"
                            required
                            value={this.state.password}
                            placeholder="Password*"
                            onChange={e => this.setState({password: e.target.value})}
                        />
                        <Form.Control.Feedback type="invalid"
                                               style={{color: '#FF666C'}}
                        >
                            Please provide a valid password.
                        </Form.Control.Feedback>
                        <div
                            style={{visibility: this.state.wrongPassword ? 'visible' : 'hidden', color: '#FF666C'}}
                        >
                            Hatalı şifre
                        </div>
                    </FormGroup>
                    <Button block
                            type="submit">
                        Log in
                    </Button>
                </Form>
                {this.state.error ? errorMsg : ""}
                <div>
                    <br></br>
                    <Link
                        to={{pathname: "/register", state: {fromUrl: 'Login'}}}
                        className="n av-link" style={{color: "white"}}>
                        Sign Up
                    </Link>
                </div>
            </div>
        );
    }
}

export default withRouter(Login);